/* DSL Voice search advanced — continuous listen mode with intent-detection */
(function(){
  var SR = window.SpeechRecognition || window.webkitSpeechRecognition;
  if (!SR) return;
  document.addEventListener("click", function(e){
    if (!e.target.matches("[data-voice-search-adv]")) return;
    var rec = new SR(); rec.lang = "nl-NL"; rec.continuous = false; rec.interimResults = true;
    var btn = e.target;
    btn.classList.add("is-listening"); btn.textContent = "🎙️ Luistert...";
    rec.onresult = function(ev){
      var t = ev.results[ev.results.length-1][0].transcript;
      if (ev.results[ev.results.length-1].isFinal) {
        btn.classList.remove("is-listening"); btn.textContent = "🎙️";
        // Intent-detect
        if (/koop|bestel|in winkelwagen/i.test(t)) {
          var match = t.match(/koop\s+(.+)|bestel\s+(.+)|in winkelwagen\s+(.+)/i);
          var query = (match[1] || match[2] || match[3] || "").trim();
          location.href = "/search?q=" + encodeURIComponent(query);
        } else if (/zoek|vind/i.test(t)) {
          location.href = "/search?q=" + encodeURIComponent(t.replace(/^(zoek|vind)\s+/i, ""));
        } else {
          location.href = "/search?q=" + encodeURIComponent(t);
        }
        if (window.DSL_AB) window.DSL_AB.track("voice_search_adv", {transcript: t});
      } else {
        btn.textContent = "🎙️ " + t;
      }
    };
    rec.onerror = rec.onend = function(){ btn.classList.remove("is-listening"); btn.textContent = "🎙️"; };
    rec.start();
  });
})();